import { cn } from "@/util/cn";
import { HelpCircle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./tooltip";

export const QuestionMarkTooltip = ({
    tooltip,
    variant = "dark",
}: { tooltip: React.ReactNode; variant?: "light" | "dark" }) => (
    <TooltipProvider delayDuration={0}>
        <Tooltip>
            <TooltipTrigger
                asChild
                className={cn("ml-1 inline-block", {
                    "hover:text-accent-flashy": variant === "dark",
                    "hover:text-gray-700": variant === "light",
                })}
            >
                <HelpCircle className="size-3.5" />
            </TooltipTrigger>
            <TooltipContent>
                <div className="font-medium">{tooltip}</div>
            </TooltipContent>
        </Tooltip>
    </TooltipProvider>
);
